import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import { useDisableScrollBar } from '../../SmoothScrollbar/useSmoothScrollbar'
import ColorExplorer from './ColorExplorer'
import CustomColorButton from './CustomColorButton'
// import ImageHover from './ImageHover'
import useScrollTrigger from '../../../hooks/useScrollTrigger'
import { createUseStyles } from '../../../helpers/createStyles'

const CustomColors = ({ data }) => {
  const classes = useStyles()
  const { colorGroups = [] } = data
  const [activeIndex, setActiveIndex] = useState(null)
  // const [hoverIndex, setHoverIndex] = useState(null)
  const handleClickColor = useCallback((colorGroup) => {
    setActiveIndex(colorGroups.indexOf(colorGroup))
  }, [colorGroups])

  // Disable scrolling while exolorer open
  useDisableScrollBar(typeof index === 'number')

  // const onMouseEnter = useCallback((i) => {
  //   setHoverIndex(i)
  // }, [])
  // const onMouseLeave = useCallback((i) => {
  //   setHoverIndex(null)
  // }, [])

  const sectionRef = useScrollTrigger(
    () => ({
      trigger: sectionRef.current,
      start: () => `${window.innerHeight / 4}px bottom`,
      scrub: false
    }),
    (tl, ref) => {
      const defaults = {
        ease: 'power2.inOut',
        duration: 0.8,
        clearProps: 'opacity'
      }
      tl.from(ref.current.children, { y: 40, opacity: 0, stagger: 0.1, ...defaults })
    }
  )

  return (
    <>
      {/* <ImageHover colorGroups={colorGroups} activeIndex={hoverIndex} /> */}
      <div ref={sectionRef} className={classes.wrapper}>
        {colorGroups.map((colorGroup, index, items) => (
          <CustomColorButton
            key={colorGroup._key}
            colorGroup={colorGroup}
            onClick={handleClickColor}
            // onMouseEnter={onMouseEnter}
            // onMouseLeave={onMouseLeave}
            index={index}
            last={index < items.length - 1}
          />
        ))}
      </div>
      <ColorExplorer
        activeIndex={activeIndex}
        groups={colorGroups}
        setActiveIndex={setActiveIndex}
      />
    </>
  )
}

CustomColors.propTypes = {
  data: PropTypes.object.isRequired
}

const useStyles = createUseStyles({
  wrapper: {
    '& button': {
      transition: 'opacity 0.3s ease-out'
    },
    '&:hover button': {
      opacity: 0.35
    },
    '& button:hover': {
      opacity: 1,
      '& .hover-lines': {
        transform: 'scaleX(1)',
        opacity: 1
      }
    }
  }
})

export default CustomColors
